import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const TeamCard = ({ className, limit }) => {
  const { t } = useTranslation();
  const teamData = t('sections.teamCard.teamData', { returnObjects: true, defaultValue: [
    { title: 'Michael Johnson', img: 'assets/img/team/team_1_1.jpg', desig: 'UI/UX Designer', bio: 'John is a seasoned cybersecurity expert with over 20 years of experience in the industry. He specializes in threat.' },
    { title: 'Justine Kingdony', img: 'assets/img/team/team_1_2.jpg', desig: 'UI/UX Designer', bio: 'John is a seasoned cybersecurity expert with over 20 years of experience in the industry. He specializes in threat.' },
    { title: 'Sarah Rahman', img: 'assets/img/team/team_1_3.jpg', desig: 'UI/UX Designer', bio: 'John is a seasoned cybersecurity expert with over 20 years of experience in the industry. He specializes in threat.' },
    { title: 'Donne Joanne', img: 'assets/img/team/team_1_4.jpg', desig: 'UI/UX Designer', bio: 'John is a seasoned cybersecurity expert with over 20 years of experience in the industry. He specializes in threat.' },
    { title: 'Michael Johnson', img: 'assets/img/team/team_1_5.jpg', desig: 'UI/UX Designer', bio: 'John is a seasoned cybersecurity expert with over 20 years of experience in the industry. He specializes in threat.' },
    { title: 'Justine Kingdony', img: 'assets/img/team/team_1_6.jpg', desig: 'UI/UX Designer', bio: 'John is a seasoned cybersecurity expert with over 20 years of experience in the industry. He specializes in threat.' },
    { title: 'Sarah Rahman', img: 'assets/img/team/team_1_7.jpg', desig: 'UI/UX Designer', bio: 'John is a seasoned cybersecurity expert with over 20 years of experience in the industry. He specializes in threat.' },
    { title: 'Donne Joanne', img: 'assets/img/team/team_1_8.jpg', desig: 'UI/UX Designer', bio: 'John is a seasoned cybersecurity expert with over 20 years of experience in the industry. He specializes in threat.' }
  ] });

  const displayTeam = limit !== undefined ? teamData.slice(0, limit + 1) : teamData;

  return (
    <>
      {displayTeam.map((member, index) => (
        <div className={className} key={index}>
          <div className="ot-team team-card">
            <div className="box-img">
              <img src={member.img} alt={member.title} />
            </div>
            <div className="box-content">
              <h3 className="box-title">
                <Link to="/team-details">{member.title}</Link>
              </h3>
              <span className="box-desig">{member.desig}</span>
              <div className="ot-social">
                <a target="_blank" rel="noopener noreferrer" href="https://facebook.com/">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/">
                  <i className="fab fa-twitter"></i>
                </a>
                <a target="_blank" rel="noopener noreferrer" href="https://instagram.com/">
                  <i className="fab fa-instagram"></i>
                </a>
                <a target="_blank" rel="noopener noreferrer" href="https://linkedin.com/">
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </div>
            </div>
            <div className="hover-wrap">
              <div className="box-content">
                <h3 className="box-title">
                    <Link to="/team-details">{member.title}</Link>
                </h3>
                <span className="box-desig">{member.desig}</span>
                <p className="box-text">{member.bio}</p>
                <div className="ot-social">
                  <a target="_blank" rel="noopener noreferrer" href="https://facebook.com/">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/">
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a target="_blank" rel="noopener noreferrer" href="https://instagram.com/">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a target="_blank" rel="noopener noreferrer" href="https://linkedin.com/">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default TeamCard;